import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import { InputLabel } from "@mui/material";

export default function AsyncAutoComplete({
  width,
  label,
  isRequired = false,
  placeholder,
  isOpen,
  height,
  onBlur,
  options,
  isLoading,
  onHandleOpenChange,
  selectedOption,
  searchInputValue,
  onSelectedOptionChange,
  onSearchInputValueChange,
  isError = false,
  errorMessage = "",
  defaultValue,
  name = "default",
  customStyles = {}
  // onBlur = () => { },
}) {
  const handleMouseLeave = () => {
    onHandleOpenChange(false); // Close the dropdown when mouse leaves the options container
  };
  return (
    <React.Fragment>
      {label ? (
        <InputLabel
          sx={{ fontSize: "14px", fontWeight: 600, marginBottom: "5px" }}
        >
          {label} {isRequired && <span style={{ color: "red" }}>*</span>}
        </InputLabel>
      ) : null}

      <Autocomplete
        sx={{
          width,
          marginTop: "5px !important",
          "& .MuiOutlinedInput-root": {
            backgroundColor: "white",
          },
          "& .MuiAutocomplete-input": {
            fontSize: "14px",
          },
          "& .MuiFormHelperText-root": {
            margin: 0,
          },
          ...customStyles
        }}
        size="small"
        open={isOpen}
        name={name}
        onBlur={onBlur}
        value={selectedOption}
        onChange={onSelectedOptionChange}
        inputValue={searchInputValue}
        onInputChange={onSearchInputValueChange}
        onOpen={() => onHandleOpenChange(true)}
        onClose={() => onHandleOpenChange(false)}
        defaultValue={defaultValue}
        autoComplete
        // includeInputInList
        // filterSelectedOptions
        isOptionEqualToValue={(option, value) => {
          return option?.value === value?.value;
        }}
        getOptionLabel={(option) => {
          return option?.label;
        }}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <li key={option?.value} {...optionProps}>
              {option?.label}
            </li>
          );
        }}
        options={options || []}
        loading={isLoading}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={isOpen ? "Search" : label || placeholder}
            error={Boolean(isError)}
            helperText={Boolean(isError) && errorMessage}
            onBlur={onBlur}
            name={name}
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {isLoading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              },
            }}
          />
        )}
        // Add mouse leave detection for options container
        ListboxProps={{
          onMouseLeave: handleMouseLeave,
        }}
      />
    </React.Fragment>
  );
}
